import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Card, Fade, makeStyles, Modal,
} from '@material-ui/core';
import { Canvas } from '@react-three/fiber';

import { GetCourseByUser } from '../../services/courses';
import { setAnalytics } from '../../utils';
import ReturnButton from '../General/ReturnButton';

import Intro from './Intro/Index';
import SoundButton from './Intro/SoundButton';
import AccessoriesContainer from './Map/html/Index';
import LoadingSede from './Map/html/LoadingSede';
import SceneMap from './Map/Index';
import LoadingWorld from './LoadingWorld';

const size = {
  width: window.innerWidth - 2,
  height: window.window.innerHeight - 2,
};
const useStyles = makeStyles((theme) => ({
  returnButton: {
    position: 'absolute',
    zIndex: 100,
    top: '4%',
    left: '2%',
  },
  loading: {
    background: theme.palette.background.primary,
  },
  modalSede: {
    background: theme.palette.background.primary,
  },
  modalSedeContainer: {
    background: theme.palette.background.primary,
  },
}));
function KonectaWorld() {
  const classes = useStyles();
  const params = useParams();
  const navigate = useNavigate();
  const { course, theme } = params;
  const { sub } = useSelector((store) => store.login);

  const showSessionValue = sessionStorage.getItem('noneInit');
  const [show, setShow] = useState(!!window.location.pathname.includes('theme'));
  const [themesByCourse, setThemesByCourse] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingHtml, setIsLoadingHtml] = useState(false);
  const [isLoadingSede, setIsLoadingSede] = useState(true);
  const [idUser, setIdUser] = useState('');

  const finishLoading = () => setIsLoading(false);
  const apiGetCourseById = async () => {
    const subValue = sub || sessionStorage.getItem('sub');
    const courseById = await GetCourseByUser(subValue, course);
    const { data } = courseById;
    setIdUser(subValue);
    const orderThemesByCourse = data[0].topicsByUser.sort((a, b) => a.createdAt - b.createdAt);
    orderThemesByCourse.push(data[0].finalProjectByUser);
    setThemesByCourse(orderThemesByCourse);

    finishLoading();
    setIsLoadingSede(false);
  };
  const handleTransition = () => {
    setShow(true);
  };
  const buttonStartChangeLoading = () => {
    setIsLoading(true);
    setIsLoadingHtml(true);
  };
  const navigateToFinalProject = () => navigate('/finalProject', { state: { course, idUser } });
  const finishLoadingHtml = () => setIsLoadingHtml(false);
  useEffect(() => {
    apiGetCourseById();
    setAnalytics('Home', 'NavPerfil_Cursos');
  }, []);

  return (
    <div style={{ width: size.width, height: size.height }}>
      <SoundButton />
      <div className={classes.returnButton}>
        {theme === undefined ? <ReturnButton /> : null }
      </div>
      { theme !== undefined
        ? (
          <Modal open={isLoadingSede} className={classes.modalSede} hideBackdrop>
            <Fade in={isLoadingSede}>
              <LoadingSede />
            </Fade>
          </Modal>
        ) : null}
      <AccessoriesContainer showValue={show} loading={finishLoadingHtml} />
      <Modal
        open={isLoadingHtml}
        className={classes.loading}
        hideBackdrop
      >
        <Card elevation={0} className={classes.modalSedeContainer}>
          <LoadingWorld />
        </Card>
      </Modal>
      <Canvas>
        { show === false && showSessionValue === 'false'
          ? (
            <Intro
              setShow={handleTransition}
              showValue={show}
              canClick={isLoading}
              changeLoading={buttonStartChangeLoading}
            />
          ) : (
            <SceneMap
              themes={themesByCourse}
              loading={finishLoading}
              finalProjectActions={navigateToFinalProject}
            />
          ) }
      </Canvas>
    </div>
  );
}

export default KonectaWorld;
